/*
 *  Product Template Scripts
 *    Scripts that are only meant to run on the Product Template.
 *
 *  Version:
 *    1.0.0 - 2020/07/13
 */

import 'slick-carousel';
import { printMoney } from './../process/pc-slate-tools';
import { Swatch, ON_VARIANT_CHANGE } from './../objects/swatch/Swatch';
import { ProductTemplateQuantitySelector } from "./../objects/quantity/ProductTemplateQuantitySelector";
import { AddToCartButton, CLASS_HIDDEN } from './../objects/product/AddToCartButton';
import * as ResponsiveSizes from './../settings/Responsive';
import { Accordion } from './../objects/accordion/Accordion';
import { CLASS_ACTIVE } from './../sections/product-carousel/ProductCarousel';

import './../sections/product-carousel/ProductCarousel';

import './../sections/product-recommendations/ProductRecommendations';


// Selectors
export const PRODUCT_TEMPLATE_CONTAINER = '[data-product-template]';
export const PRODUCT_ADD = '[data-product-template-add-to-cart]';
export const PRODUCT_MONEY = '[data-product-money]';
export const PRODUCT_COMPARE_MONEY = '[data-product-compare-price]';
export const PRODUCT_ALTERNATE_PAYMENT_MONEY = '[data-alternate-money-price]';
export const PRODUCT_STOCK_SELECTOR = '[data-product-stock]';
export const PRODUCT_BADGE_SELECTOR = '[data-product-badge]';
export const PRODUCT_SKU_SELECTOR = '[data-product-sku]';
export const PRODUCT_ENQUIRY_CONTAINER = '[data-product-enquiry-container]';
export const PRODUCT_ENQUIRY_OPEN = '[data-product-enquiry-open]';
export const PRODUCT_ENQUIRY_CLOSE = '[data-product-enquiry-close]';
export const PRODUCT_SWATCH_CONTAINER = '[data-swatch]';
export const PRODUCT_COLOR_SWATCHES = '[data-product-size-swatches]';
export const PRODUCT_COLOR_SWATCH = '[data-product-color-swatch]';
export const PRODUCT_ACCORDION = '[data-product-accordion]';
export const PRODUCT_SCROLL_TRIGGER = '[data-product-details-scroll]';
export const PRODUCT_DESCRIPTION_SELECTOR = '[data-product-description]';
export const PRODUCT_WISHLIST_BUTTON = '[data-product-wishlist-button]';

// Attributes
export const SWATCH_OPTION_ATTR = 'data-swatch-option-name';

class ProductTemplate {
  constructor(container) {
    // Elements
    this.container = container;
    this.productMoney = container.find(PRODUCT_MONEY);
    this.productCompare = container.find(PRODUCT_COMPARE_MONEY);
    this.alternatePaymentPrice = container.find(PRODUCT_ALTERNATE_PAYMENT_MONEY);
    this.productStock = container.find(PRODUCT_STOCK_SELECTOR);
    this.productBadge = container.find(PRODUCT_BADGE_SELECTOR);
    this.productSku = container.find(PRODUCT_SKU_SELECTOR);
    this.enquiryContainer = container.find(PRODUCT_ENQUIRY_CONTAINER);
    this.colorSwatches = container.find(PRODUCT_COLOR_SWATCHES);
    this.sizeSwatches = container.find(`${PRODUCT_SWATCH_CONTAINER} [${SWATCH_OPTION_ATTR}="Size"]`);
    this.wishlistButtons = container.find(PRODUCT_WISHLIST_BUTTON);

    this.isWholesaleCustomer = this.isCustomerWholesale();

    // Setup product swatches and add to cart
    this.swatches = new Swatch(this.container);
    this.quantitySelector = new ProductTemplateQuantitySelector(this, this.container);
    this.addToCart = new AddToCartButton(this, this.container.find(PRODUCT_ADD));

    // Colour (fake) swatch carousel
    if(this.colorSwatches.find(PRODUCT_COLOR_SWATCH).length > 3) {
      this.colorSwatchSlick = this.initColourSwatchCarousel();
    }

    // Setup product accordion
    this.productAccordion = new Accordion(this.container.find(PRODUCT_ACCORDION));

    // Events
    $(document).on(ON_VARIANT_CHANGE, (e, variant) => this.onVariantChanged(variant));
    $(container).on('click touchend', PRODUCT_ENQUIRY_OPEN, e => this.onEnquiryOpen(e));
    $(document).on('click touchend', PRODUCT_ENQUIRY_CLOSE, e => this.onEnquiryClose(e))
    $(container).on('click touchend', PRODUCT_SCROLL_TRIGGER, e => this.onDescriptionScroll(e));

    // Mutation Observers
    let wishlistObserver = new MutationObserver(this.wishlistButtonCB);
    document.querySelectorAll(PRODUCT_WISHLIST_BUTTON).forEach((el) => {
      wishlistObserver.observe(el, {
        attributes: true
      });
    });
  }

  wishlistButtonCB(mutations) {
    for(let mutation of mutations) {
      if(mutation.attributeName === 'class') {
        let self = $(mutation.target);

        if(self.hasClass('is-saved')) {
          $(PRODUCT_WISHLIST_BUTTON).addClass('is-saved');
        } else {
          $(PRODUCT_WISHLIST_BUTTON).removeClass('is-saved');
        }
      }
    }
  }

  isCustomerWholesale() {
    let customer = window.Customer;

    if(!customer || !customer.tags) return false;

    for(let i = 0; i < customer.tags.length; i++) {
      let tag = customer.tags[i];

      if (
        tag.indexOf('tier-RRP') !== -1 ||
        tag.indexOf('tier-Stockist') !== -1 ||
        tag.indexOf('tier-BNM') !== -1 ||
        tag.indexOf('tier-ECommerce') !== -1 ||
        tag.indexOf('tier-Designer') !== -1 ||
        tag.indexOf('tier-Hospitality') !== -1 ||
        tag.indexOf('tier-TPW') !== -1
      ) {
        return true;
      }
    }

    return false;
  }

  initColourSwatchCarousel() {
    let slick = this.colorSwatches.slick({
      mobileFirst: true,
      slidesToShow: 3,
      infinite: true,
      dots: false,
      arrows: true,
      focusOnSelect: false,
      centerMode: false,
      draggable: true,
      adaptiveHeight: false,
      swipeToSlide: true,
      variableWidth: true
    });

    return slick;
  }

  onEnquiryOpen(e) {
    e.preventDefault();
    let windowWidth = window.innerWidth;

    /**
     * Different behaviour depending on the screen size.
     * Everything excluding mobile screens will animate the form in using a class
     */
    if(windowWidth > ResponsiveSizes.small - 1) {
      this.enquiryContainer.addClass(CLASS_ACTIVE);
    }
  }

  onEnquiryClose(e) {
    e.preventDefault();

    let self = $(e.currentTarget);
    let windowWidth = window.innerWidth;

    /**
     * Different behaviour depending on the screen size.
     * Small screens will trigger the lity close
     * Everything else will animate the form out by removing a class
     */
    if(windowWidth > ResponsiveSizes.small - 1) {
      this.enquiryContainer.removeClass(CLASS_ACTIVE);
    } else {
      self.parents('.lity-container').find('[data-lity-close]').trigger('click');
    }
  }

  onVariantChanged(variant) {
    let { price } = variant;

    // Adjust Price Display
    if(!price || price <= 0) {
      this.productMoney.removeAttr('data-money'); // Stops any currency converters attempting to convert.
      this.productMoney.html('FREE'); // TODO: Make this not hard coded.
    } else {
      let postfixText = `
        <span class="c-product-template__price-price-postfix">
          ${Language.strings['products.general.gst']}
        </span>
      `;

      this.productMoney.attr('data-money', price);
      // TODO: Talk to bold support about dynamic pricing for variants.
      // App currently stops us from updating pricing
      // this.productMoney.html(`
      //   <span class="money" data-product-id="${variant.id}">
      //     ${printMoney(price)}
      //   </span>
      // `);
      this.productMoney.html(printMoney(price));
      this.alternatePaymentPrice.html(printMoney(price / 4, 'money_format'));
    }

     // Adjust stock levels
     let stockLevel = variant.inventory_quantity < 0 ? 0 : variant.inventory_quantity;
     let stockLevelText = `${Language.strings['products.product.in_stock']}`
     .replace('{{ stock }}', stockLevel);
     this.productStock.html(stockLevelText);

     // Adjust sku numbers
     let sku = variant.sku
     if(sku) {
       this.productSku.each((i, e) => $(e).html(sku));
     } else {
       this.productSku.each((i, e) => $(e).html(' '));
     }

    // Adjust price display (wholesale compares regular price)
    if(!this.productCompare) return;
    if (!this.isWholesaleCustomer || price == 0) {
      this.productCompare.removeAttr("data-money");
      this.productCompare.html("");
    } else {
      let prefixText = `
        <span class="o-product-pricing__money-postfix o-product-pricing__price-postfix">
          ${Language.strings['products.general.rpp']}
        </span>
      `;
      this.productCompare.attr("data-money", price);
      this.productCompare.html(prefixText + printMoney(price));
    }
  }

  onDescriptionScroll(e) {
    e.preventDefault();
    let scrollPoint = this.container.find(PRODUCT_DESCRIPTION_SELECTOR).offset().top;
    $('html, body').animate({scrollTop: scrollPoint}, 700);
  }
}

$(document).ready($(PRODUCT_TEMPLATE_CONTAINER).each((i, e) => new ProductTemplate($(e))));